<template>
  <div>
    <el-table
      v-loading="loading"
      v-if="showTable"
      :data="courseList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '60'
            : widthMax < 1199
            ? '60'
            : widthMax > 1200
            ? '80'
            : ''
        "
        :index="(index) => indexMethod(index, page, pageSize)"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="ชื่อหลักสูตร"
        header-align="center"
        sortable
        :width="widthMax < 767.98 ? '120' : widthMax < 1199 ? '130' : ''"
      ></el-table-column>
     <el-table-column
        prop="approved"
        label="ผู้เข้าร่วมหลักสูตร"
        header-align="center"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="studying"
        label="ผู้กำลังเรียน"
        header-align="center"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="success"
        label="ผู้จบหลักสูตร"
        header-align="center"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="วันและเวลาที่อัปเดตล่าสุด"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row.updatedAt | dateTimeTh
        }}</template>
      </el-table-column>
    </el-table>
    <div v-if="totalCourse > pageSize" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalCourse"
        :page-size="pageSize"
        :current-page="page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  computed: {
    token(){
      return this.$store.state.token
    }
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      courseList:[],
      page:1,
      pageSize:10,
      totalCourse:0,
      loading:true
    };
  },
  mounted() {
    this.fetchDashboardCourseAll()
    window.addEventListener("resize", this.resize);
    this.widthMax= window.innerWidth
    setTimeout(() => {
      this.showTable = true
    }, 200);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    changePage(page) {
      this.loading = true
      this.page = page;
      this.fetchDashboardCourseAll();
    },
    fetchDashboardCourseAll() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`dashboard/course/all/${(this.page-1)*this.pageSize}/${this.pageSize}`)
        .then((res) => {
          if (res.data.success) {
            this.courseList = res.data.obj.data
            this.totalCourse = res.data.obj.total
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchDashboardCourseAll error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>